const swiper = new Swiper(".result-swiper", {
  slidesPerView: 2,
  breakpoints: {
    // 768px以上の場合
    768: {
      slidesPerView: 1
    }
  },
  loop: true, // ループ有効
  speed: 6000, // ループの時間
  allowTouchMove: false, // スワイプ無効
  autoplay: {
    delay: 0 // 途切れなくループ
  }
});

var bar = document.querySelector(".progressbar_in");
var speed = 5000;
window.onload = function() {
  var swiper = new Swiper(".mv-slide", {
    loop: true,
    autoplay: {
      delay: speed,
      disableOnInteraction: false
    },
    on: {
      slideChangeTransitionStart: function() {
        (bar.style.transitionDuration = "0s"), (bar.style.transform = "scaleY(0)");
      },
      slideChangeTransitionEnd: function() {
        (bar.style.transitionDuration = speed + "ms"), (bar.style.transform = "scaleY(1)");
      }
    }
  });
};

jQuery(window).on("scroll", function() {
  let length = 100;
  if (jQuery(".top-mv").length) {
    length = jQuery(".top-mv").innerHeight();
  }
  if (length < jQuery(this).scrollTop()) {
    jQuery("header, #floating").attr("data-scroll", "true");
  } else {
    jQuery("header,#floating").attr("data-scroll", "false");
  }
});
